import React, { useState } from "react";
import { Radio,Select, Row, Col, Form, Upload, DatePicker, Input, Button, message, Tooltip, Checkbox } from "antd";
import { PlusOutlined, UploadOutlined } from '@ant-design/icons';
import "./FormRegistroSesion.scss";
import moment from 'moment';
import 'moment/locale/es';
import logoAyuda from "../../../assets/img/icono_interroga.svg";
import logoAyudaH from "../../../assets/img/icono_interrogaHover.svg";
moment.locale('es');
let j=0;
    let i=0;
export default function FormRegistroSesion(props) {
    //console.log("PROPS SESION", props)
    var fechaCreacion = moment().format('DD-MM-YYYY');
    var tiempoMensaje = 5;
    let tempArt = [];
    
 
   props.articulos.map((item) => (
    //console.log("item", item),
    item.tipoArticulo === 1 ? i++:j++
                           ))
  

    const handleGuardaSesion = (e) => {
        e.preventDefault();
        props.form.validateFieldsAndScroll((err, values) => {
            //console.log("values en handleGuardaSesion()", values);
            //valores = [...valores, 'fechaHora'];

            if (!err) {
                //console.log('Received values of form: ', values);
                values.articulos=articulosSeleccionados;
                props.handleSubmit(values);
                /*Modal.confirm({
                    title: '¿Está seguro de guardar la información?',
                    icon: <ExclamationCircleOutlined />,
                    //content: 'Some descriptions',
                    okText: 'Aceptar',
                    cancelText: 'Cancelar',
                    onOk() {
                        console.log('Aceptar');
                        props.handleSubmit(values);
                    },
                    onCancel() {
                        console.log('Cancelar');
                    },
                });*/
            }
        });
    };
    //archivor=cargaArchivo.archivo;
    // const fechaActual= date.getDate() + "-" + (date.getMonth() +1) + "-" + date.getFullYear();


    //const handleValuesChange = () => console.log('Value changes');
   const [tipoCaptura, setTipoCaptura] = useState(null); 
   const [articulosSeleccionados, setArticulosSeleccionados] = useState([])

   const handleValuesChange= e => {
    //  let value = e.target.value;
      setTipoCaptura( e.target.value)
       //console.log("selected  tipo articulo:=>", e.target.value);
       props.articulos.map((itemA) => {

        //  console.log("CHECKBOX", itemA)
        if ((itemA.tipoArticulo ===  e.target.value) || (e.target.value === 0)) {
           return (itemA.checked = false)
        }
    })

    setArticulosSeleccionados([])
    };
    const { getFieldDecorator } = props.form;

    const dateFormat = "DD-MM-YYYY";

    /*const [visibleAlert, setVisibleAlert] = useState({
        activado: false,
        tipoMensaje: "",
        mensaje: ""
    });*/

   /*  const [cargaArchivo, setCargaArchivo] = useState({
        archivo: null,
        consultar: false,
        urlPDF: null
    }); */
    const [cargaArchivo, setCargaArchivo] = useState(props.file);


    const propsUpload = {
        multiple: false,
        /* onRemove: file => {
            setCargaArchivo(cargaArchivo => {
                return {
                    file: cargaArchivo.archivo
                };
            });
        }, */
        onRemove: file => {
            setCargaArchivo(file);
        },
        beforeUpload: file => {
            const isPDF = file.type === 'application/pdf';
            const isSomething = file.size > 0;
            const isSize = (file.size / 1024 / 1024) <= 50; //Limita hasta 250 MB
            
           if (!isPDF) {
                /*  setVisibleAlert({
                     activado: true,
                     tipoMensaje: "error",
                     //mensaje: "El formato del archivo no corresponde a un CSV. Favor de verificarlo."
                     mensaje: "El formato del archivo no corresponde a un PDF. Favor de borrarlo y cargar uno válido."
                 }); */
                message.error("El formato del archivo no corresponde a un PDF. Favor de borrarlo y cargar uno válido.", tiempoMensaje);
                return true;
            }
            if (!isSomething) {
                /* setVisibleAlert({
                    activado: true,
                    tipoMensaje: "error",
                    //mensaje: "El archivo viene vacío. Favor de verificarlo."
                    mensaje: "El archivo se encuentra vacío. Favor de borrarlo y cargar uno válido."
                }); */
                message.error("El archivo se encuentra vacío. Favor de borrarlo y cargar uno válido.", tiempoMensaje);
                return true;
            }
            if (!isSize) {
                /* setVisibleAlert({
                    activado: true,
                    tipoMensaje: "error",
                    //mensaje: "El archivo pesa más de 10 MB. Favor de verificarlo."
                    mensaje: "El archivo pesa más de 50 MB. Favor de borrarlo y cargar uno válido."
                }); */
                message.error("El archivo pesa más de 50 MB. Favor de borrarlo y cargar uno válido.", tiempoMensaje);
                return false;
            }
            else {
                /* const url = URL.createObjectURL(file);
                setCargaArchivo({
                    archivo: file,
                    urlPDF: url,
                    consultar: true,
                }); */
                setCargaArchivo(file);
                /* setVisibleAlert({
                    activado: true,
                    tipoMensaje: "success",
                    mensaje: "El archivo fue cargado exitosamente. Para poder subir otro PDF primero debe eliminar el existente."
                }); */
                message.success("El archivo fue cargado exitosamente. Para subir un nuevo PDF, solo selecciónalo.", tiempoMensaje);

            }
            return false;
        },
        cargaArchivo,
        showUploadList: {
            showRemoveIcon: false,
            
          },
    };


    function changeBackgroundh(e) {
        e.target.style.backgroundImage = `url(${logoAyudaH})`;
        e.target.style.backgroundRepeat="no-repeat"
      }
      function changeBackground(e) {
        e.target.style.backgroundImage = `url(${logoAyuda})`;
        e.target.style.backgroundRepeat="no-repeat"
      }

      const onChangeA = item => {

        //console.log("CHECKBOX9", item.target.checked, "valor", item.target.value)
        //console.log("CHECKBOX v", item.target.value)
        // console.log("CHECKBOX c", item.target.checked)

        // tempReg=props.articulosR.articulos.filter((r) => r.checked != false); 

        //console.log("CHECKBOX9a", articulosSeleccionados)
        //setArtSeleccionados(tempReg.articulos.articulo)
        if (item.target.checked ===true) {
            articulosSeleccionados.push(item.target.value)
            //console.log("CHECKBOX6", articulosSeleccionados)
        }
        if (item.target.checked === false) {
            tempArt = articulosSeleccionados.filter((r) => r !== item.target.value);
            setArticulosSeleccionados(tempArt)
            //console.log("CHECKBOX7", articulosSeleccionados)
        }

        //artSeleccionados.articulo.push(item.target.value)
        //artSeleccionados.checked.push(item.target.checked)

       // regAux = registros;
       props.articulos.map((itemA) => {

            //console.log("CHECKBOX", itemA)
            if (itemA.idArticulo === item.target.value) {
                return itemA.checked = item.target.checked
            }

        });
       //console.log("pruebas h", articulosSeleccionados);
       // setRegistros(regAux);

        // 

        //setArticulosSeleccionados(artTemp)


    };
    
    return (
        <div>
            <h1 className="titulo-sesion">Sesión del OPL</h1>
            <label className="texto-14-sesion">Los datos con ( <label className="rojo-sesion">*</label> ) son requeridos.</label>
            <br />
            <br />
            {props.mostrarFormulario && <div>
                <Form onSubmit={handleGuardaSesion} layout="vertical">
                    <Row>
                        <Col span={4}>
                            <Col span={23}>
                                <label className="rojo-sesion">* </label><label className="texto-16-sesion">Fecha de sesión</label>
                            </Col>
                        </Col>
                        <Col span={5}>
                            <Col span={23}>
                                <label className="rojo-sesion">* </label><label className="texto-16-sesion">Tipo de sesión</label>
                            </Col>
                        </Col>
                        <Col span={5}>
                            <Col span={23}>
                                <label className="rojo-sesion">* </label><label className="texto-16-sesion">Número de acuerdo</label>
                            </Col>
                        </Col>
                        
                       
                    </Row>
                   
                    <Row>
                        <Col span={4}>
                            <Col span={23}>
                                <Form.Item name="fechaSesion" hasFeedback>
                                    {getFieldDecorator('fechaSesion', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Seleccione la fecha de la sesión.',
                                            }
                                        ],
                                    })(
                                        <DatePicker
                                            placeholder="Seleccione"
                                            format={dateFormat}
                                            locale={'es'}
                                            disabledDate={current => {
                                                return current.startOf('day').diff(moment().startOf('day'), 'days') > 0
                                            }}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Col>
                        <Col span={5}>
                            <Col span={23}>
                                <Form.Item name="tipoSesion" hasFeedback>
                                    {getFieldDecorator('tipoSesion', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Seleccione un tipo de sesion.',
                                            }
                                        ],
                                    })(
                                        <Select
                                            placeholder="Seleccione una opción"
                                        >
                                            {props.optionsTiposSesion.map((value, index) => {
                                                return <Select.Option key={value}>{value}</Select.Option>;
                                            })}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Col>
                        <Col span={5}>
                            <Col span={23}>
                                <Form.Item name="numeroAcuerdo" hasFeedback>
                                    {getFieldDecorator('numeroAcuerdo', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Ingrese número de acuerdo.',
                                            }
                                        ],
                                    })(<Input placeholder="Ingrese número de acuerdo"
                                        maxLength={50}
                                    />)}
                                </Form.Item>
                            </Col>
                        </Col>
                        
                    </Row>
                    <Row>
                    <Col span={23}>
                            <Col span={23}>
                                <label className="rojo-sesion">* </label><label className="texto-16-sesion">Nombre del acuerdo</label>
                            </Col>
                        </Col>
                        </Row>
                   
                    <Row>
                    <Col span={23}>
                            <Col span={23}>
                                <Form.Item name="nombreAcuerdo" hasFeedback>
                                    {getFieldDecorator('nombreAcuerdo', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Ingrese nombre del acuerdo.',
                                            }
                                        ],
                                    })(<Input placeholder="Ingrese nombre del acuerdo"
                                        maxLength={1000}
                                    />)}
                                </Form.Item>
                            </Col>
                        </Col>
                    </Row>
                    <Row>
                    <Col span={4}>
                            <Col span={23}>
                            <label className="rojo-sesion">* </label> <label className="texto-16-sesion">Tipo de artículo relacionado</label>
                            </Col>
                        </Col>
                        <Col span={10}>
                            <Col span={23}>
                                <label className="texto-16-sesion">Observaciones</label>
                            </Col>
                        </Col>
                        <Col span={4}>
                        <Col span={23}>
                            <label className="rojo-sesion">* </label><label className="texto-16-sesion"> Acuerdo/documento
                            < Tooltip placement = "bottom"
                            title = "El tamaño máximo del archivo a subir es de 50 MB" >
                                <Button 
                            className="icono-ayuda"    
                            type = "link"
                            //shape = "circle"
                            size = "small"
                            style = {
                                {
                                    //transform: "translateY(7.1%)",
                                    backgroundImage: `url(${logoAyuda})`,
                                    backgroundRepeat: "no-repeat"

                                }
                            }

                            //href={pdfAyuda}
                            target = "_blank"
                            onMouseOver = {
                                changeBackgroundh
                            }
                            onMouseOut = {
                                    changeBackground
                                } >

                                </Button> </Tooltip>
                            </label>
                            </Col>
                        </Col>

                    </Row>
                    <Row>
                    <Col span={4}>
                            <Col span={23}>
                                <Form.Item name="tipoArticulo" hasFeedback>
                                    {getFieldDecorator('tipoArticulo', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Seleccione un tipo de artículo relacionado a la sesion.',
                                            }
                                        ],
                                    })(
                                        <Radio.Group
                                        onChange={handleValuesChange} > 
                                        <Radio value={2}> Documentos </Radio><br/>
                                        <Radio value={1}> Materiales </Radio><br/>
                                        <Radio value={0}> Ambos </Radio>
                                        <br/>
                                         <br/><span/>
                                    </Radio.Group>
                                   
                                   )}
                                </Form.Item>
                            </Col>
                        </Col>
                        <Col span={10}>
                            <Col span={23}>
                                <Form.Item name="observaciones">
                                    {getFieldDecorator('observaciones', {})(
                                        <Input.TextArea placeholder="Ingrese las observaciones" rows={3} autoSize={{ minRows: 2, maxRows: 3 }} allowClear={true} maxLength={1500} />
                                    )}
                                </Form.Item>
                            </Col>
                        </Col>
                        <Col span={4}>
                            <Col span={23}>
                            <Form.Item name="fechaCaptura" hasFeedback>


                                {getFieldDecorator('Archivo', {
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Debe subir el archivo del acuerdo.',
                                        }
                                    ],
                                })
                                    (
                                        <Upload {...propsUpload} accept=".pdf"
                                        fileList={cargaArchivo !== undefined && cargaArchivo !== null ? [cargaArchivo] : []}>
                                            <Button type="submit" className="subir">
                                                <UploadOutlined /> Subir </Button>
                                        </Upload>
                                    )}
                                {
                                    <label className="texto-16-sesion" value={fechaCreacion}> {fechaCreacion} </label>
                                }

                            </Form.Item>
                            </Col>
                        </Col>
                   </Row>
                   {//console.log("tipo",tipoCaptura, "j",j, "i",i)
                   }
                   {((tipoCaptura === 2 && j>0) 
                   || (tipoCaptura === 1 && i>0) 
                   || (tipoCaptura === 0 && (j>0||i>0))) ?
                    <>                  <Row>
                                    {//console.log("tamaño", registros.articulos.length)
                                    }
                                    <Col span={23}>
                                        
                                        
                                        
                                    <label className="texto-16-sesion">
                                            Artículos aprobados 
                                            
                                        </label>
                                        <br />

                                    </Col>
                                </Row>
                                <br />

                                <Row>

                                    <Col>

                                        <Form.Item>

                                            {//console.log("props", props.verificacion)
                                            }
                                           
                                               {     getFieldDecorator
                                                        ('checksDocumentos', {

                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: 'Seleccion el nombre de (los) documento(s) que se están aprobando',
                                                                }
                                                            ]
                                                        })
                                                        (
                                                            // <Checkbox.Group>
                                                            <Row>
                                                                {
                                                                    //console.log("CHECKBOX2****", articulosSeleccionados, "tipo", tipoCaptura)
                                                                }
                                                                {
                                                                    props.articulos.map((item) => (
                                                                        item.tipoArticulo === tipoCaptura ?
                                                                        <Col span={24} >
                                                                            <Checkbox className="checkArticulo" defaultChecked={item.checked} checked={item.checked} value={item.idArticulo} onChange={onChangeA}/>{item.articulo}
                                                                        </Col>:tipoCaptura===0 &&<Col span={24}>
                                                                            <Checkbox className="checkArticulo" defaultChecked={item.checked} checked={item.checked} value={item.idArticulo} onChange={onChangeA}>{item.articulo}</Checkbox>
                                                                        </Col>)
                                                                        )

                                                                }

                                                            </Row>
                                                            //   </Checkbox.Group>





                                                        )
                                                   
                                                            }
                                        </Form.Item>

                                    </Col>
                                </Row>
                                </>:

                               ( (tipoCaptura === 2 && j< 1) 
                                || (tipoCaptura === 1 && i < 1) 
                                || (tipoCaptura === 0 && (j<1 && i<1))) &&
                                                 <Row>
                                                 {//console.log("tamaño", registros.articulos.length)
                                                 }
                                                 <Col span={23}>
                                                     
                                                     
                                                     
                                                 <label className="rojo-sesion"> </label><label className="texto-16-sesion">
                                                         Artículos aprobados 
                                                         
                                                     </label>
                                                     <br />
                                                    <label className="texto-16-sesion">No se cuenta con artículos validados para ser aprobados</label>
             
                                                 </Col>
                                             </Row>
                                }
                   <Row> 

                        <Col span={23} >

                            <Col span={23} className="alinear">
                                <Form.Item >
                                    <Button className="agregar" type="primary" htmlType="submit" disabled={!props.enableAgregar}>
                                        <PlusOutlined />Agregar
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Col>
                    </Row>


                </Form>
            </div>
            }
        </div>
    )
}